import { createContext, useContext, useMemo } from "react";
import { useMutation } from "react-query";
import { User } from "../api/user";
import { useAuth } from "./useAuth";
import { useSearchParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { RootState } from "../store";

export type UserActivityLogPayload = {
    event_internal_name: string;
    source: "WEB_MOBILE" | "WEB_DESKTOP";
};

type UserActivityLogContextType = {
    track: (eventName: string) => Promise<void>;
};

const UserActivityLogContext = createContext<UserActivityLogContextType | null>(null);

export const UserActivityLogProvider = ({ children }: { children: React.ReactNode }) => {
    const { isAdmin, isAuthenticated } = useAuth();
    const [searchParams] = useSearchParams()
    // Read source from URL (no router dependency)
    const app_source = searchParams.get('source') as undefined | 'app-synchro';
    const restricted = useSelector<RootState>(state => state.user.restrictedMode) as boolean

    // Mutation to send tracking data
    const trackMutation = useMutation((data: UserActivityLogPayload) =>
        User.sendTrackingLogs(data)
    );

    const track = async (eventName: string) => {


        //Dont send on admin 
        //Dont send on no event name  
        //Dont send if user not auth or restricted 
        if (isAdmin || !eventName || !isAuthenticated || restricted) return


        const payload: UserActivityLogPayload = {
            event_internal_name: eventName,
            source: app_source === "app-synchro" ? "WEB_MOBILE" : "WEB_DESKTOP",
        };


        try {
            await trackMutation.mutateAsync(payload);
        } catch {
            console.warn("Track event not sent : " + eventName);
        }
    };

    return (
        <UserActivityLogContext.Provider value={{ track }}>
            {children}
        </UserActivityLogContext.Provider>
    );
};

export const useUserActivityLog = () => {
    const ctx = useContext(UserActivityLogContext);
    if (!ctx) throw new Error("useUserActivityLog must be used inside <UserActivityLogProvider>");
    return ctx;
};
